import React from "react";
import { Col } from "antd";
import { Form, Button, Icon } from "antd";
import { Field, reduxForm } from "redux-form";
import RenderField from "../common/renderField";
import { withTranslation } from "react-i18next";
import { maxLength15, maxLength50, required } from "./Validate";
import Title from "../common/Title";
import Description from "../common/Description";
import Hint from "../common/Hint";
import BackArrow from "../common/leftrightbluearrow";

const FormItem = Form.Item;

const lang = window.lang;

const PersonalityVerification = (props) => {
  const { previousPage, handleSubmit, invalid } = props;
  const { t } = props;

  const formItemLayout = {
    wrapperCol: {
      style: { float: window.lang === "en" ? "left" : "right" },
      xs: { span: 24 },
      sm: { span: 8 },
    },
  };
  const tailFormItemLayout = {
    wrapperCol: {
      style: { float: window.lang === "en" ? "left" : "right" },
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
  };

  return (
    <Col xs={{ span: "24" }} sm={{ span: "24" }}>
      <div id="pageID" style={{display: 'none'}}>pageCustomerDetails</div>
      <Button className="back-btn" onClick={previousPage}>
        <BackArrow />
      </Button>
      <Title title={"mobily_fiber"} />
      <Hint hint={"personality_step"} id={"Step3"} />

      <Description description={"personality_desc"} />

      <Form onSubmit={handleSubmit} className={"mt-5"}>
        <Field
          formItemLayout={formItemLayout}
          name="firstName"
          type="text"
          component={RenderField}
          label={t("first_name")}
          validate={[required, maxLength50]}
          id="firstName"
        />
        <div
          style={{
            marginTop: "3rem",
          }}
        >
          <Field
            formItemLayout={formItemLayout}
            name="lastName"
            type="text"
            component={(props) => <RenderField {...props} mt={"mt-5"} />}
            label={t("last_name")}
            validate={[required, maxLength50]}
            id="lastName"
          />
        </div>
        <Field
          formItemLayout={formItemLayout}
          style={{
            marginTop: "3rem",
          }}
          name="idNumber"
          type="text"
          component={(props) => <RenderField {...props} mt={"mt-5"} />}
          label={t("id_number")}
          validate={[required, maxLength15]}
          hint={t("id_hint")}
          id="idNumber"
        />
        <FormItem {...tailFormItemLayout} className={"mt-5 pt-5"}>
          <Button
            shape="round"
            block
            disabled={invalid}
            type="primary"
            htmlType="submit"
            className={lang === "en" ? "next-btn " : "next-btn-a "}
            id="customerDetails-NextBtn"
          >
            {t("next_btn")}
            <Icon type={window.lang === "en" ? "arrow-right" : "arrow-left"} />
          </Button>
        </FormItem>
      </Form>
    </Col>
  );
};

export default withTranslation()(
  reduxForm({
    form: "wizard", //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(PersonalityVerification)
);
